import * as React from "react";

import { SearchEntry } from "@common/components/Atoms/SearchFilters";

/*===========================================================================
  Page-level search controls for page > header > center
/*======================================================================== */

interface MessagesPageHeaderCenterProps {
    keyword: string,
    onKeywordSubmit: (string) => void
};


export const MessagesPageHeaderCenter: React.SFC<MessagesPageHeaderCenterProps> = (props: MessagesPageHeaderCenterProps) => (
    <div className="c-page__searches">
        <SearchEntry
            label="keywords"
            submitOnEnter={true}
            keyword={props.keyword}
            onSubmit={props.onKeywordSubmit}
        />
    </div>
);

